export const jump = {
    type:"JUMP"
}

export const low = {
    type:"LOWER"
}

export const gameOver = {
    type:"GAMEOVER"
}

export const gameOn = {
    type:"GAMEON"
}

export const startCount = {
    type:"STARTCOUNT"
}

export const endCount = {
    type:"ENDCOUNT"
}

export const gamePlayed = {
    type:"GAMEPLAYED"
}

export const gameUnPlayed = {
    type:"GAMEUNPLAYED"
}